import { RfxStatus, RfxType } from "newui/features/Rfx/types/rfx.types";
import { RFX_STATUS } from "utils/constants";

export const isRFxClosed = (status: string) => {
	return RFX_STATUS.ACTIVE !== status?.toUpperCase();
};

export const isRfxOnboardingType = (rfxType: RfxType | string): boolean => {
	let code = rfxType === typeof "string" ? rfxType : (rfxType as RfxType)?.code;

	return rfxType ? code.toLowerCase() === "onb" : false;
};

export const isRfxStatusMatch = (
	rfxStatus: string,
	expectedStatus: RfxStatus
): boolean => {
	return rfxStatus?.toUpperCase() === expectedStatus?.toUpperCase();
};
